<template>
  <div class="no-scroll-bar">
    <Navbar v-if="!isDesktop" @desktopNavigate="navigateBackToMode" :current_mode="'inside'" />
    <NavbarDesktop
      :isOrderEditMenu="edit_order?true:false"
      @onDiscardAction="adding_dish = true"
      @onConfirmAction="onEditFinish"
      :adding_dish="adding_dish"
      v-else-if="!adding_dish"
    />
    <div class="edit-container" v-if="!adding_dish">
      <QueueItem
        :cafe="cafe"
        :order="initialOrder"
        @changeQuantity="handleQuantityChange"
        @finishEdit="onEditFinish"
        @showAddDishUI="adding_dish = true"
      />
    </div>

    <AddDish
      editing_order
      @addMany="handleAddDish"
      @close="adding_dish = false"
      v-if="adding_dish"
    />
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";

import QueueItem from "@/components/QueueItem.vue";

import AddDish from "@/components/modals/AddDish.vue";
import NavbarDesktop from "@/components/NavbarDesktop.vue";

export default {
  components: {
    Navbar,
    NavbarDesktop,
    QueueItem,
    AddDish,
  },
  data() {
    return {
      edit_order: {},
      adding_dish: false,
    };
  },
  methods: {
    backToOrders() {
      this.$router.push("/orders");
    },
    onEditFinish() {
      if (this.initialOrder.list.length == 0) {
        this.$store.dispatch("queue/cancelOrder", {
          order_id: this.initialOrder._id,
          reason: this.$t("refuse.delete_reason"),
        });
      } else {
        this.$store.dispatch("queue/editOrder", {
          order_id: this.$route.params.order_id,
        });
      }

      this.$router.push("/orders");
    },
    handleQuantityChange(order_id, item_index, delta) {
      const index = this.findOrderIndex(order_id);

      this.$store.commit("queue/changeOrderItemQuantity", {
        index,
        item_index,
        delta,
      });
    },
    handleAddDish(items) {
      const index = this.findOrderIndex(this.$route.params.order_id);

      items.forEach((item) => {
        this.$store.commit("queue/addItemToOrderList", {
          index,
          item,
        });
      });

      this.adding_dish = false;
    },
    findOrderIndex(order_id) {
      let idx = -1;

      this.orders.forEach((order, index) => {
        if (order._id === order_id) {
          idx = index;
        }
      });

      return idx;
    },
    navigateBackToMode(mode) {
      this.$router.push({
        name: "orders",
        query: {
          m: mode,
        },
      });
    },
  },
  mounted() {
    this.edit_order = JSON.parse(JSON.stringify(this.initialOrder));
  },
  computed: {
    isDesktop() {
      return window.innerWidth > 768;
    },
    initialOrder() {
      return this.$store.getters["queue/getOrderById"](
        this.$route.params.order_id
      );
    },
    cafe() {
      return this.$store.state.cafe;
    },
    orders() {
      return this.$store.state.queue.orders;
    },
    menu() {
      return this.$store.state.menu;
    },
  },
};
</script>

<style>
.edit-container {
  padding-top: 16vw;
  margin-bottom: 16vh;
}
@media screen and (min-width: 768px) {
  div.edit-container {
    display: flex;
    justify-content: center;
    padding-top: 9.722vw;
    margin-bottom: 0;
  }
  .edit-container::-webkit-scrollbar {
    width: 0;
  }
}
</style>